// src/store/useFavoritesStore.js
import { create } from 'zustand';

const COOKIE_NAME = 'favorites';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 365 дней

function readCookieJSON(name) {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([$?*|{}\]\\^])/g, '\\$1') + '=([^;]*)')
  );
  try {
    return m ? JSON.parse(decodeURIComponent(m[1])) : null;
  } catch {
    return null;
  }
}

function writeCookieJSON(name, value, maxAge = COOKIE_MAX_AGE) {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; Path=/; Max-Age=${maxAge}`;
}

// чтобы синхронизировать между вкладками — зеркалим в localStorage (cookie не триггерит events)
function broadcast(ids) {
  try {
    localStorage.setItem('__fav_broadcast__', JSON.stringify({ ids, ts: Date.now() }));
  } catch {}
}

function loadInitial() {
  const arr = readCookieJSON(COOKIE_NAME);
  return Array.isArray(arr) ? arr.map(String) : [];
}

export const useFavoritesStore = create((set, get) => ({
  favorites: loadInitial(), // массив строк (slug или id как строка)

  isFavorite: (key) => get().favorites.includes(String(key)),

  toggleFavorite: (key) => {
    const id = String(key);
    const curr = get().favorites;
    const next = curr.includes(id) ? curr.filter(x => x !== id) : [id, ...curr];
    writeCookieJSON(COOKIE_NAME, next);
    broadcast(next);
    set({ favorites: next });
  },

  clearFavorites: () => {
    writeCookieJSON(COOKIE_NAME, []);
    broadcast([]);
    set({ favorites: [] });
  },

  // слушаем локальное событие из других вкладок (и из этой же — на всякий случай)
  _initSync: (() => {
    if (typeof window === 'undefined') return () => {};
    const onStorage = (e) => {
      if (e.key === '__fav_broadcast__') {
        const data = (() => { try { return JSON.parse(e.newValue); } catch { return null; } })();
        if (data && Array.isArray(data.ids)) set({ favorites: data.ids.map(String) });
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  })(),
}));
